export const endpoints = {
  code: (codetableId: number) => `optionsCollection/${codetableId}/code`,
  subsets: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}/subset`,
  optionsCollectionSearch: (codetableId: number) => `optionsCollection/${codetableId}/search`,
  language: 'code/language/options',
  caseType: 'code/caseType/options',
  userGroup: 'code/usergroup/options',
  excludableFields: (optionsCollectionId: number) => `optionsCollection/${optionsCollectionId}/fieldNodes`,
  consequenceSeverityFields: 'code/uom/options',
  duplicateCode: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}:duplicate`
};
